export interface IconRadioSelectorProps {
    items: IconRadioItemProps[];
    selected: number|string;
    onSelect: (id: number|string) => void;
    small?: boolean;
}

export const IconRadioSelector = ({items, selected, onSelect, small}: IconRadioSelectorProps) => {
    return (
        <div className="d-flex flex-row">
            {items.map((it,idx) => (
                <IconRadioItem
                    key={it.id}
                    {...it}
                    small={small??false}
                    active={it.id === selected}
                    onSelect={() => onSelect(it.id)}
                    last={idx===items.length-1}
                />
            ))}
        </div>
    )
}

export interface IconRadioItemProps {
    id: number|string;
    name: string;
    icon: string;
}
const IconRadioItem = ({name, icon, active, onSelect, last, small}: IconRadioItemProps & {active: boolean, last: boolean, small: boolean, onSelect: () => void}) => {
    return (
        <div role="button" onClick={onSelect} className={"d-flex flex-column align-items-center " + (active ? "text-primary":"") + (last ? "":" me-3")}>
            <div className={"icon-radio-item " + (small ? "p-3":"p-4")  + (active ? " border-primary":"")} style={{}}>
                <span>
                    {small && <span><i className={icon + ' fa-fw fa-xl'}/></span> }
                    {!small && <span><i className={icon + ' fa-fw fa-2x'}/></span> }
                </span>
            </div>
            <h6>{name}</h6>
        </div>
        
    )
}